window._mode='front';window._protocol='https://';window._domain='www.votre-etiquette.com';window._diroot='';window._theme='default';window._webdir='web';window._themedir='web/_themes/ve/';window._api='/api/v2/';
import Interface from 'theme/index.js';

(async () => {
    await Interface();

    if (document.querySelector('.blog-comment-reply-link'))
    {
        document.querySelectorAll('.blog-comment-reply-link').forEach(e =>
        {
            e.addEventListener('click', event =>
            {
                event.preventDefault();
                const id_comment = e.dataset.idComment;
                bg_move_form(`#blog-comment-${id_comment}`, id_comment);
            });
        });
    }

    if (document.querySelector('.blog-link-cancel-comment'))
    {
        document.querySelectorAll('.blog-link-cancel-comment').forEach(e =>
        {
            e.addEventListener('click', event =>
            {
                event.preventDefault();
                bg_move_form(`#blog-comment-container`, 0);
            });
        });
    }
})();

function bg_move_form(target, parent)
{
    try
    {
        document.querySelector(target).append(document.getElementById('blog-form-comment'));
        document.getElementById('blog-id-parent').value = parent;
        if (parent == 0) {
            document.querySelector('.blog-link-cancel-comment').classList.remove('active');
            document.querySelector('.blog-comment-reply-link').classList.add('active');
        } else {
            document.querySelector('.blog-comment-reply-link').classList.remove('active');
            document.querySelector('.blog-link-cancel-comment').classList.add('active');
        }
    } catch (e) {
        throw new cwException(e);
    }
}